import { StyleSheet } from 'react-native';

import { pt, px, is_android } from '../../common/utils';

export default StyleSheet.create({
    container: {
        flex: 1,
        paddingHorizontal: pt(20),
        backgroundColor: '#EFEFEF'
    },
    content_wrap: {
        paddingVertical: pt(20)
    },
    // 点点点
    info_cont: {
        marginTop: pt(-21)
    },
    tooth: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginHorizontal: 'auto',
        marginBottom: pt(-4),
        width: pt(300),
        height: pt(12)
    },
    dot_white: {
        width: pt(12),
        height: pt(12),
        overflow: 'hidden',
        borderRadius: pt(6),
        backgroundColor: '#fff'
    },
    // 文字
    info: {
        paddingHorizontal: pt(12),
        paddingVertical: pt(18),
        backgroundColor: '#fff',
        borderRadius: pt(5)
    },
    info_top: {
        marginBottom: pt(4)
    },
    info_title: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: pt(9)
    },
    title: {
        fontSize: pt(15),
        color: '#4032E6',
        fontWeight: 'bold'
    },
    title_img: {
        marginRight: pt(5),
        width: pt(12),
        height: pt(15)
    },

    info_container: {
        position: 'relative',
        paddingLeft: pt(16),
        width: pt(295)
        // flex: 1,
        // flexDirection: 'row',
        // alignItems: 'flex-start'
    },
    dot: {
        position: 'absolute',
        left: 0,
        top: pt(4),
        marginRight: pt(5),
        marginTop: pt(5),
        width: pt(10),
        height: pt(10),
        borderRadius: pt(5),
        backgroundColor: '#4032E6',
        overflow: 'hidden'
    },
    info_text: {
        // flex: 1,
        lineHeight: pt(26),
        fontSize: pt(12),
        color: '#666'
    },
    // 底部按钮
    footer: {
        height: pt(50),
        backgroundColor: '#FF4F18',
        justifyContent: 'center',
        alignItems: 'center'
    },
    pay: {
        color: '#fff',
        lineHeight: pt(22),
        fontSize: pt(16),
        fontFamily: 'PingFangSC-Regular'
    },

    // 支持影院
    supportCinema: {
        backgroundColor: '#fff',
        marginTop: pt(10)
    },
    support_title: {
        paddingVertical: pt(13)
        // borderBottomWidth: px(2),
        // borderBottomColor: 'rgba(0,0,0,0.1)'

    },
    title_text: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    line: {
        width: pt(30),
        height: pt(1),
        backgroundColor: '#ccc'
    },
    support_title_text: {
        fontSize: pt(16),
        fontWeight: 'bold',
        marginHorizontal: pt(5)
    },
    cinema_num: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: pt(5)
    },
    located: {
        width: pt(11),
        height: pt(13),
        marginRight: pt(3)
    },
    num_text: {
        fontSize: pt(12),
        color: '#898989'
    },

    cinema_item_wrap: {
        paddingVertical: pt(12),
        borderTopWidth: px(2),
        borderTopColor: 'rgba(0,0,0,0.1)'
    },
    cinema_name_price_wrap: {
        flexDirection: 'row',
        alignItems: 'center',
        marginBottom: pt(7)
    },
    cinema_name: {
        flex: 1,
        fontSize: pt(14),
        color: '#252525',
        marginRight: pt(8)
    },
    cinema_address_wrap: {
        // flexDirection: 'row',
        // alignItems: 'center',
        // justifyContent: 'space-between'
    },
    cinema_address: {
        fontSize: pt(12),
        color: '#898989'
        // width: pt(270)
    },

    city_item: {
        height: pt(40),
        borderTopWidth: px(2),
        borderTopColor: 'rgba(0,0,0,0.1)',
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginHorizontal: pt(10)
    },
    city_name: {
        fontSize: pt(14),
        color: '#252525',
        fontWeight: 'bold'
    }
});
